<template>

    <header :class="type">
        <!-- <div class="bg-header"></div> -->
        <div class="container">
            <router-link to="/" tag="div" class="logo">
                <span class="shape"></span>
                <span class="text"></span>
            </router-link>
            <a href="" class="btn main txt-blk" @click.prevent="scrollParent" v-if="type === 'dft'">
                <span class="hvr"></span>
                <span class="txt">Try for free</span>
            </a>
            <slot v-if="type === 'dash'"></slot>
        </div>
    </header>

</template>

<script>

    // import Global from '../lib/GlobalState'

    export default {

        name: 'Headbar',

        props: {
            type: String
        },

        data() {
            return {
                // Global
            }
        },

        methods: {

            scrollParent() {
                this.$parent.scrollToNeeds()
            }

        }

    }

</script>